import { isEuMember } from "is-eu-member";
import cookies from "js-cookie";

export function isQuebec(country) {
  const REGION_CODE_COOKIE_KEY = "cf-region-code";
  const IP_COUNTRY_COOKIE_KEY = "cf-ipcountry";

  return (
    country.toLowerCase() === "ca" &&
    cookies.get(IP_COUNTRY_COOKIE_KEY)?.toLowerCase() == "ca" &&
    cookies.get(REGION_CODE_COOKIE_KEY)?.toLowerCase() == "qc"
  );
}

export function isConsentRequired(locale) {
  let country = parseLocale(locale).country;

  if (country) {
    country = country.toLowerCase();
    return (
      isEuMember(country) ||
      isQuebec(country) ||
      country === "ch" ||
      country === "no" ||
      country === "gb"
    );
  }

  return false;
}

function parseLocale(locale) {
  if (!locale) {
    return {};
  }

  const langCountry = locale.split("-");

  return {
    language: langCountry[0],
    country:
      langCountry.length > 1 ? langCountry[langCountry.length - 1] : undefined,
  };
}
